import React, { useState } from "react";
import styled from "@emotion/styled";
import { HeadLine } from "../HeadLine";
import { CLink } from "../Anchor";
import { PrimaryButton, SecondaryButton } from "../Button";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "./thunk";

const Container = styled.div`
  background: #ffffff;
  box-shadow: 0 0 50px rgba(31, 32, 33, 0.08);
  border-radius: 50px 0 0 0;
  z-index: 2;
`;

const Wrapper = styled.div`
  width: 468px;
  height: 568px;
  display: flex;
  padding: 1rem;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
`;

const Actions = styled.div`
  margin-top: 50px;
`;

const Body = styled.div`
  width: 356px;
`;

const Input = styled.div`
  &:last-of-type {
    margin-top: 25px;
  }
`;

const ForgotPassword = styled.span`
  display: flex;
  justify-content: flex-end;
`;

const ForgotPasswordLink = styled(CLink)`
  text-transform: uppercase;
`;

const DontHaveAccount = styled.div`
  text-align: center;
  margin: 2rem 0;
`;

const DontHaveAccountH2 = styled.h2`
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #e1eaed;
  line-height: 0.1em;
  margin: 10px 0 20px;
`;

const DontHaveAccountText = styled.span`
  background: #ffffff;
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  text-align: center;
  padding: 0 10px;
  text-transform: uppercase;
  color: #777984;
  line-height: 0px;
`;

const ErrorMessage = styled.div`
  font-size: 10px;
  padding-top: 1rem;
  color: red;
`;

const CustomerSignin = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const message = useSelector((state) => state.localSecurity);
  const [emailAddress, setEmailAddress] = useState("");
  const [emailAddressError, setEmailAddressError] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState(false);

  const onEmailChange = (email) => {
    setEmailAddress(email);

    const EMAIL_REGEX =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (EMAIL_REGEX.test(email) || email.includes(">")) {
      setEmailAddressError(false);
    } else {
      setEmailAddressError(true);
    }
  };

  const onPassChange = (pass) => {
    setPassword(pass);

    if (pass) {
      setPasswordError(false);
    } else {
      setPasswordError(true);
    }
  };

  const submitButtonDisabled =
    emailAddressError ||
    passwordError ||
    emailAddress.length < 5 ||
    password.length < 2;

  return (
    <Container>
      <Wrapper>
        <HeadLine headingText={"Sign In"} />
        <Body>
          <form
            id="sign-in"
            onSubmit={(e) => {
              e.preventDefault();
              if (!submitButtonDisabled) {
                dispatch(loginUser(emailAddress, password));
              }
            }}
          >
            <Input>
              <label htmlFor="email">email</label>
              <input
                type="text"
                name="email"
                autoComplete="email"
                placeholder="Your email address"
                onChange={(e) => onEmailChange(e.target.value.trim())}
                required
              />
              {emailAddressError && (
                <ErrorMessage>Invalid Email Address</ErrorMessage>
              )}
              <ForgotPassword>
                <ForgotPasswordLink to={"/pass-assist/"}>
                  Forgot PASSWORD?
                </ForgotPasswordLink>
              </ForgotPassword>
            </Input>
            <Input>
              <label htmlFor="password">Password</label>
              <input
                type="password"
                name="password"
                autoComplete="current-password"
                placeholder="Password"
                onChange={(e) => onPassChange(e.target.value.trim())}
                required
              />
              {passwordError && <ErrorMessage>Invalid Password</ErrorMessage>}
            </Input>
            <Actions>
              <PrimaryButton disabled={submitButtonDisabled} type="submit">
                Sign In
              </PrimaryButton>
              {message.length && <ErrorMessage>{message}</ErrorMessage>}
              <DontHaveAccount>
                <DontHaveAccountH2>
                  <DontHaveAccountText>
                    Don't have an account yet?
                  </DontHaveAccountText>
                </DontHaveAccountH2>
              </DontHaveAccount>
              <SecondaryButton onClick={() => history.push("/sign-up")}>
                Create Account
              </SecondaryButton>
            </Actions>
          </form>
        </Body>
      </Wrapper>
    </Container>
  );
};

CustomerSignin.propTypes = {};

export { CustomerSignin };
